import config from '../config'
import http from '../http'

export default{
	//仓库端根据flagId显示标记，描述
	getFlagById: async function(payload) {
		const res = await http({
			url: config.GET_FLAG_BY_ID,
			method: 'get',
			data:{
				...payload
			},
			
		})
		return res.data
	},
	//获取订单的总数
	getOrderCount: async function(payload) {
		const res = await http({
			url: config.GET_ORDER_COUNT,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	//更新旗帜描述
	updataUserFlageDesc: async function(payload) {
		const res = await http({
			url: config.UPDATA_USER_FLAG_DESC,
			method: 'post',
			data:payload
		})
		return res.data
	},
	//getUserFlags
	getUserFlags: async function(payload) {
		const res = await http({
			url: config.GET_USER_FLAGE,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},
	//增加用户的旗帜
	addUserFlags: async function(payload) {
		const res = await http({
			url: config.ADD_USER_FLAGE,
			method: 'post',
			data:payload
			
		})
		return res.data
	},
	//设置旗帜
	setOrderFlag:async function(payload) {
		const res = await http({
			url: config.SET_ORDER_FLAG,
			method: 'post',
			data:{
				...payload
			}
			
		})
		return res.data
	},
	//异步获取取件方式
	getLogisticInfo:async function(payload) {
		const res = await http({
			url: config.GET_LOGISTICS_INFO,
			method: 'get',
			data:{
				...payload
			}
			
		})
		return res.data
	},
	//点击开始生成运单号，再调此方法获取最新的订单
	getNewOrders:async function(payload) {
		const res = await http({
			url: config.GET_NEW_ORDERS,
			method: 'post',
			data:payload
			
		})
		return res.data
	},
	//获取仓库帐号的订单
	getStoreOrders:async function(payload) {
		const res = await http({
			url: config.GET_STORE_ORDER,
			method: 'post',
			data:payload
		})
		return res.data
	},
	
	//合并打印订单
	printMergerOrders:async function(payload) {
		const res = await http({
			url: config.PRINT_MERGERORDERS,
			method: 'post',
			data:payload
		})
		return res.data
	},
	//扫描枪打包出库
	setPackaged:async function(payload) {
		const res = await http({
			url: config.SET_PACKAGED,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},
	//开始准备订单数据
	startReadyOrders:async function(payload) {
		const res = await http({
			url: config.START_READY_ORDERS,
			method: 'post',
			data:payload
		})
		return res.data
	},
	//安排订单
	arrangement:async function(payload) {
		const res = await http({
			url: config.ARR_RANGE_MENT,
			method: 'post',
			data:payload
		})
		return res.data
	},
	//增加打印次数
	addPrintNum:async function(payload) {
		const res = await http({
			url: config.ADD_PRINT_NUM,
			method: 'post',
			data:payload
		})
		return res.data
	},
	//获取订单商品
	getOrderItems:async function(payload) {
		const res = await http({
			url: config.GET_ORDERS_ITEM,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取所有参数数据
	getParams:async function(payload) {
		const res = await http({
			url: config.GET_PARAMS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取所有订单
	getAllOrders:async function(payload) {
		const res = await http({
			url: config.GET_ORDERS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
}